import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=3b4ae664&"
import script from "./UserAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserAccount.vue?vue&type=style&index=0&id=3b4ae664&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports